module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlak7.d3c4ab90.jpg";